<template>
  <WsStateDropdownRadio001
    v-model="state"
    :dropdown-menu-item="items"
    :placeholder="placeholder"
    outline
  />
</template>

<script>
export default {
  data() {
    return {
      placeholder: this.$t("不限頻率"),
      state: "all",
      items: [
        {
          id: "all",
          textLabel: this.$t("不限頻率"),
        },
        {
          id: "day",
          textLabel: this.$t("每日"),
        },
        {
          id: "week",
          textLabel: this.$t("每週"),
        },
        {
          id: "month",
          textLabel: this.$t("每月"),
        },
        {
          id: "season",
          textLabel: this.$t("每季"),
        },
      ],
    }
  }
}
</script>